import React, {FC} from 'react'
import {useSelector} from 'react-redux'
import {RootState} from 'setup/redux/RootReducer'

interface Props {
  selectedClubIds: string[]
  onChange: (selectedClubs: string[]) => void
}

interface WineClubSubscription {
  subscriptionId: string
  name: string
}

const WineClubSelection: FC<Props> = ({selectedClubIds, onChange}) => {
  const wineClubSubscriptions = useSelector(
    (state: RootState) => state.customers?.customer?.customerDetails?.wineClubSubscriptions || []
  )

  const handleSelectAll = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.checked) {
      onChange(
        wineClubSubscriptions.map(
          (subscription: WineClubSubscription) => subscription.subscriptionId
        )
      )
    } else {
      onChange([])
    }
  }

  const handleClubSelect = (clubId: string) => (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.checked) {
      onChange([...selectedClubIds, clubId])
    } else {
      onChange(selectedClubIds.filter((id: string) => id !== clubId))
    }
  }

  if (!wineClubSubscriptions.length) return null

  return (
    <div className='mb-5'>
      <h4 className='fw-boldest fs-6 mb-4'>Set as Default Payment for Wine Clubs</h4>
      <div className='py-2'>
        <label className='form-check form-check-inline form-check-solid me-5'>
          <input
            type='checkbox'
            id='chkSelectAllWineClubs'
            name='selectAllWineClubs'
            checked={selectedClubIds.length === wineClubSubscriptions.length}
            onChange={handleSelectAll}
            className='form-check-input'
          />
          <span className='fw-bold ps-2 fs-6'>Select All Wine Clubs</span>
        </label>
      </div>
      {wineClubSubscriptions.map((subscription: WineClubSubscription) => (
        <div key={subscription.subscriptionId} className='py-2'>
          <label className='form-check form-check-inline form-check-solid me-5'>
            <input
              type='checkbox'
              id={`chkWineClub_${subscription.subscriptionId}`}
              name={`wineClub_${subscription.subscriptionId}`}
              checked={selectedClubIds.includes(subscription.subscriptionId)}
              onChange={handleClubSelect(subscription.subscriptionId)}
              className='form-check-input'
            />
            <span className='fw-bold ps-2 fs-6'>{subscription.name}</span>
          </label>
        </div>
      ))}
    </div>
  )
}

export default WineClubSelection
